import { ActionConfig, HierarchicalActionTypes } from "../types"
import { scopeNoneLabel } from "./helpers"

export function actionHuman(
  scopeOne: "campaigns" | "adGroups" | "ads",
  a: ActionConfig,
  actionTypes?: HierarchicalActionTypes,
  adSource: "yandex_direct" | "vk_ads" = "yandex_direct"
): string {
  if (!a.actionType || a.actionType === "none") {
    return scopeNoneLabel(scopeOne)
  }

  // Если это API ID (число), ищем в структуре данных
  if (actionTypes && !isNaN(Number(a.actionType))) {
    const sourceId = adSource === "yandex_direct" ? "2" : "9"
    const sourceActions = actionTypes[sourceId]

    if (sourceActions) {
      // Проверяем в other действиях
      const otherAction = sourceActions.other?.find(
        (action) => action.id.toString() === a.actionType
      )

      if (otherAction) {
        if (otherAction.id === 1) {
          // "Ничего не меняем"
          return scopeNoneLabel(scopeOne)
        } else if (otherAction.id === 4) {
          // "Отключаем"
          const scopeLabel = getScopeLabel(scopeOne)
          return `Отключаем ${scopeLabel}`
        }
      }

      // Проверяем в increase/decrease действиях
      const increaseAction = sourceActions.increase?.find(
        (action) => action.id.toString() === a.actionType
      )
      const decreaseAction = sourceActions.decrease?.find(
        (action) => action.id.toString() === a.actionType
      )

      if (increaseAction) {
        return `${increaseAction.name} на ${a.budgetAmount} ${
          a.budgetUnit === "percent" ? "%" : "руб."
        }`
      }

      if (decreaseAction) {
        return `${decreaseAction.name} на ${a.budgetAmount} ${
          a.budgetUnit === "percent" ? "%" : "руб."
        }`
      }
    }
  }

  // Fallback для старых значений
  if (a.actionType === "disable") return `Отключаем ${getScopeLabel(scopeOne)}`

  const actionLabels: Record<string, string> = {
    increase_budget: "Увеличиваем недельный бюджет",
    increase_conversion_price: "Увеличиваем цену конверсии",
    increase_avg_cpc: "Увеличиваем среднюю цену клика",
    increase_max_cpc: "Увеличиваем максимальную цену клика",
    increase_daily_budget: "Увеличиваем дневной бюджет",
    increase_view_price: "Увеличиваем цену за просмотр",
    increase_1000_views_price: "Увеличиваем цену за 1000 показов",
    increase_1000_views_max_cost: "Увеличиваем макс. стоимость 1000 показов",
    increase_conversion_max_cost: "Увеличиваем макс. стоимость конверсии",
    decrease_budget: "Уменьшаем недельный бюджет",
    decrease_conversion_price: "Уменьшаем цену конверсии",
    decrease_avg_cpc: "Уменьшаем среднюю цену клика",
    decrease_max_cpc: "Уменьшаем максимальную цену клика",
    decrease_daily_budget: "Уменьшаем дневной бюджет",
    decrease_view_price: "Уменьшаем цену за просмотр",
    decrease_1000_views_price: "Уменьшаем цену за 1000 показов",
    decrease_1000_views_max_cost: "Уменьшаем макс. стоимость 1000 показов",
    decrease_conversion_max_cost: "Уменьшаем макс. стоимость конверсии",
  }

  const actionLabel = actionLabels[a.actionType] || a.actionType
  return `${actionLabel} на ${a.budgetAmount} ${
    a.budgetUnit === "percent" ? "%" : "руб."
  }`
}

// Вспомогательная функция для получения правильного названия объекта
function getScopeLabel(scopeOne: "campaigns" | "adGroups" | "ads"): string {
  switch (scopeOne) {
    case "campaigns":
      return "кампанию"
    case "adGroups":
      return "группу объявлений"
    case "ads":
      return "объявление"
    default:
      return "объект"
  }
}
